import { render, staticRenderFns } from "./UserLanguageSwitcher.vue?vue&type=template&id=64949ab0&"
import script from "./UserLanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./UserLanguageSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports